import './component.scss'

function initializeTextToggle() {
  const moreButtons = document.querySelectorAll('.js-reform-example-card__more-button');

  moreButtons.forEach(button => {
    const text = button.closest('.reform-example-card__text-container').querySelector('.js-reform-example-card__text');

    // line-clampを一時的に解除してテキストの高さを測定
    text.style.webkitLineClamp = 'none';
    text.style.lineClamp = 'none';
    text.style.overflow = 'visible';

    // DOM更新を待つ
    requestAnimationFrame(() => {
      const fullHeight = text.scrollHeight;

      // line-clampを復元
      text.style.webkitLineClamp = '2';
      text.style.lineClamp = '2';
      text.style.overflow = 'hidden';

      // DOM更新を再度待つ
      requestAnimationFrame(() => {
        const clampedHeight = text.offsetHeight;

        // 3行以下の場合は「もっと見る」ボタンを非表示にする
        if (fullHeight <= clampedHeight + 5) { // 5pxのマージンを追加
          button.classList.add('hidden');
          return;
        }
      });
    });

    // ボタンをクリックした時はカードのリンク先に遷移する
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      window.location.href = button.closest('.reform-example-card').href;
    });
  });
}

window.addEventListener('load', function () {
  // テキスト展開機能を初期化
  initializeTextToggle();
});
